<div style="width: 95%;" [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
    <div mat-dialog-title class="modal-header-bg d-flex justify-content-end px-3 pt-1"></div>
    <div mat-dialog-content>
      <h4 class="font-weight-bold title-text">
        {{ "suggestion-modal-title" | translate }}
        <img src="assets/img/Suggestion.svg" alt="Suggestion" class="withdraw-icon">
      </h4>
      <p class="text-muted-special subtitle-text">{{ "suggestion-modal-subtitle" | translate }}</p>
  
      <div class="settings-profile">
        <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
          <div class="overlay-content">
            {{ "choose-account" | translate }}
          </div>
        </div> -->
        <form #suggestionForm="ngForm" (ngSubmit)="submitSuggestion(suggestionForm)">
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label class="required form-field-title">{{ "suggestion-body" | translate }}</label>
              <textarea [placeholder]="'suggestion-body' | translate" [(ngModel)]="newSuggestion.Body" #Body="ngModel" name="Body" class="form-control notes-textarea" rows="4" required></textarea>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end" style="justify-content: end">
            <button class="btn btn-primary" type="submit" [disabled]="suggestionForm.invalid || isSubmitting || !selectedAccount">
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
              {{ "send" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>